import { render, staticRenderFns } from "./DDownload.vue?vue&type=template&id=4119242e&scoped=true&"
import script from "./DDownload.vue?vue&type=script&lang=js&"
export * from "./DDownload.vue?vue&type=script&lang=js&"
import style0 from "./DDownload.vue?vue&type=style&index=0&id=4119242e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4119242e",
  null
  
)

export default component.exports